// To prevent jshint errors
/*global Modernizr:true */
/*jshint devel:true */
/*global $:false */

// jQuery('.event-filter').on('click', function(event) {
//     event.preventDefault();
//     var locationId = $(this).data('location_id');
//
//     jQuery('.list-events-filter > li').each(function(index, el) {
//         // console.log(el);
//         jQuery(el).removeClass('current');
//     });
//     jQuery(this).parent().addClass('current');
//     getEvents(locationId);
// });

(function ($) {

    $('#js-events-filter').on('changed.bs.select', function (e) {
        // console.log(e);
        // console.log($(e.target).val());

        var locationId = $(e.target).val();
        if(locationId != '') {
            getEvents(locationId);
        }
    });

})(jQuery);

// Using ajax, to get gallery image urls
function getEvents(locationId) {
    "use strict";

    var data = {
        action: 'get_events',
        events_nonce: events_vars.events_nonce,
        location_id: locationId
    };

    jQuery.ajax({
        type: 'post',
        dataType: 'html',
        url: events_vars.events_ajax_url,
        data: data,
        beforeSend: function() {
            // console.log('sending');
            var eventsWrapper = jQuery('#events-wrapper');
            eventsWrapper.html( '<p class="h3 text-center filter-status">Loading Posts...</p>' );
        },
        success: function( data, textStatus, jqXHR ) {
            // console.log(data);
            var eventsWrapper = jQuery('#events-wrapper');
            eventsWrapper.html( data );
        },
        error: function( MLHttpRequest, textStatus, errorThrown ) {
            // console.log(errorThrown);
        }
    });
}